import { createFileRoute } from '@tanstack/react-router'
import { InvoiceDetailFeature } from '@/features/invoices/ui/InvoiceDetailFeature'
import { PermissionGuard } from '@/shared/components/PermissionGuard'
import { PERMISSIONS } from '@/shared/config/permissions'

export const Route = createFileRoute('/invoices/$invoiceId')({
  component: InvoiceDetailRoute,
  staticData: { authorize: true },
})

function InvoiceDetailRoute() {
  const { invoiceId } = Route.useParams()
  return (
    <PermissionGuard permission={PERMISSIONS.FinanceView}>
      <InvoiceDetailFeature invoiceId={Number(invoiceId)} />
    </PermissionGuard>
  )
}
